import React, {createContext, useContext, useState} from 'react';
import {CompanyContext} from "./CompanyContext";

const AccessContext = createContext({});

export function AccessProvider({ children }) {
  const [companyContext, setCompanyContext] = useContext(CompanyContext);

  const [access, setAccess] = useState(null);
  const [client, setClient] = useState(null);

  const accessClient = (c) => {
    setClient(c)
  };

  const getAccess = (client) => {
    if (!companyContext?.company?.orgChart) {
      return null;
    }
    return {
      ready: true,
      parent: companyContext?.company?.orgParent,
      child: companyContext?.company?.orgChild,
      currentOrg: client?.companyGuid === companyContext?.company?.guid,
      companyName: client?.companyName,
      orgOwner: companyContext?.company?.orgChart?.orgOwner,
      orgChart: companyContext?.company?.orgChart
    }
  }

  const [callbackResp, setCallbackResp] = useState('');

  return (
    <AccessContext.Provider value={{ accessClient, getAccess }}>
      {children}
    </AccessContext.Provider>
  );
}


export function useAccess() {
  const context = useContext(AccessContext);
  if (!context) {
    throw new Error('AccessContext must be used within a Provider');
  }
  return context;
}

